var map = {
	"./cn/ct.png": "lz2D",
	"./en/ct.png": "NNK/",
	"./th/ct.png": "Wgrh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HYxS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1 ^\.\/.*\/ct\.png$
// module id = HYxS
// module chunks = 1